import utils from '../../utils/util.js';

module.exports = {
    methods: {
        wechatH5Share(title, desc, icon) {
            if (!utils.isWechat()) {
                return;
            }
            let link = window.location.href;









































        }
    }
}